import { createContext } from 'react';
import { DEFAULT_CURRENCY } from '@fiverr-private/homepage_utils';
import { TailoredHomepageInitialProps } from '../../../lib/interfaces/initialProps';

export const MetadataContext = createContext<{
    rollouts: TailoredHomepageInitialProps['rollouts'];
    currency: TailoredHomepageInitialProps['currency'];
}>({
    rollouts: {},
    currency: DEFAULT_CURRENCY,
});
